import React from "react";

import { Provider } from "src/components/providers/Provider";
import { Router } from "src/navigation/Router";
import {TerminalTimeGate} from 'src/components/providers/TerminalTimeGate';

export const App: React.FC = () => (
  <Provider>
    <div className="app" data-testid="page">
      <TerminalTimeGate><Router /></TerminalTimeGate>
    </div>
  </Provider>
);
